export {
  mdiAccountCogOutline,
  mdiAccountGroupOutline,
  mdiAccountNetworkOutline,
  mdiAccountOutline,
  mdiAccountTieOutline,
  mdiAlertCircle,
  mdiAlertCircleOutline,
  mdiApps,
  mdiArrowDown,
  mdiArrowLeft,
  mdiArrowRight,
  mdiArrowRightBottom,
  mdiArrowUp,
  mdiBankOutline,
  mdiCalendarBlankOutline,
  mdiCalendarOutline,
  mdiCardAccountDetailsOutline,
  mdiCheck,
  mdiCheckCircle,
  mdiCheckCircleOutline,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiClockTimeFiveOutline,
  mdiClose,
  mdiCloseCircleOutline,
  mdiContentCopy,
  mdiCurrencyGbp,
  mdiDatabaseOutline,
  mdiDeleteOutline,
  mdiDotsGrid,
  mdiDotsVertical,
  mdiDownloadOutline,
  mdiEmail,
  mdiExclamationThick,
  mdiEye,
  mdiEyeOutline,
  mdiFacebook,
  mdiFileTree,
  mdiFileUploadOutline,
  mdiFilterVariant,
  mdiFormatListBulleted,
  mdiFormatListNumbered,
  mdiHelpCircleOutline,
  mdiHomeOutline,
  mdiInformation,
  mdiInstagram,
  mdiListBoxOutline,
  mdiLoading,
  mdiLock,
  mdiLockOutline,
  mdiLogin,
  mdiLogout,
  mdiMagnify,
  mdiMagnifyPlusOutline,
  mdiMapClockOutline,
  mdiMapMarkerOutline,
  mdiMapMarkerStarOutline,
  mdiMenu,
  mdiPageFirst,
  mdiPageLast,
  mdiPencil,
  mdiPencilOutline,
  mdiPhone,
  mdiPin,
  mdiPinOutline,
  mdiPlus,
  mdiRefresh,
  mdiShieldAccount,
  mdiShieldLockOpenOutline,
  mdiShieldLockOutline,
  mdiStar,
  mdiTrashCanOutline,
  mdiUnfoldLessHorizontal,
  mdiUnfoldMoreHorizontal,
  mdiUpload,
  mdiUploadOutline,
  mdiVoteOutline,
  mdiWeatherNight,
  mdiWeb,
  mdiWhatsapp,
  mdiWhiteBalanceSunny,
  mdiYoutube,
} from '@mdi/js'

export const mdiX =
  'M17.866 2.78h3.128l-6.834 7.812L22.2 21.219h-6.295l-4.93-6.446-5.642 6.446H2.203l7.31-8.356L1.8 2.781h6.455l4.457 5.892ZM16.769 19.347h1.733L7.313 4.554H5.453Z'
